<template>
  <div class="jjfa_all">
    <div class="jjfa_nei">
        <div class="jjfa_img">
          <img class="imgg"
            :src="itemData.imgUrl"
            ></img>
        </div>
        <div class="jjfa_text">
            <div class="jjfa_text_tou">
              <div class="jjfa_text_tou_1">{{itemData.itemTitle}}</div>
              <div class="jjfa_text_dd" @click="jjfaCK">
                <div class="jjfa_text_dd_1">{{itemData.itemMore}}</div>
                <div><i class="el-icon-right jjss"></i></div>
              </div>
            </div>

          <div class="jjfa_text_count">
            {{itemData.itemCount}}
          </div>
          <div class="jjfa_text_tatil" v-for="item in itemData.itemData" @mouseover="mouseover(item.index)" @click="selectItem(item.index)" :style="{backgroundColor:item.back}">
            <div class="jjfa_text_tatil_1" :style="{color:item.p1}" >{{item.text1}}</div>
            <div class="jjfa_text_tatil_2"><i class="el-icon-right jjss"></i></div>
          </div>
        </div>

    </div>
  </div>
</template>
<style>
.jjss{
  font-size: 13px;
}
.imgg{
  width: 100%;
  height: 100%;
}
.jjfa_img{
  width: 72%;
  aspect-ratio: 1080/740;
}
.jjfa_text_tatil_2{
  margin-right: 20px;
}
.jjfa_text_tatil_1{
  font-family: SourceHanSansCN;
  font-size: 24px;
  color: #000000;
  letter-spacing: 0;
  text-align: justify;
  margin-left: 20px;
}
.jjfa_text_tatil{
  width: 100%;
  /*height: 128px;*/
  aspect-ratio: 442/128;
  display: flex;
  margin-top: 10px;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.jjfa_text{
  margin-left: 30px;
  width: 26%;
}
.jjfa_text_count{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  text-align: justify;
  line-height: 22px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.jjfa_text_dd_1{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  text-align: justify;
}
.jjfa_text_tou_1{
  font-family: SourceHanSansCN;
  font-size: 30px;
  color: #333333;
  letter-spacing: 0.64px;
  text-align: justify;
}
.jjfa_text_dd{
  display: flex;
  cursor: pointer;
  max-height: 20px;
}
.jjfa_text_tou{
  display: flex;
  margin-top: 50px;
  align-items: center;
  justify-content: space-between;

}
.jjfa_nei{
  width: 78.13%;
  /*height: 678px;*/
  display: flex;
}
.jjfa_all{
  width: 100%;
  /*height: 860px;*/
  display: flex;
  justify-content: left; /* 水平居中 */
  align-items: flex-end; /* 垂直居中 */
  margin-top: 50px;
  margin-bottom: 50px;

}
</style>
<script>
import {Data} from "../js/image/jjfa";

export default {
  name: "jjfa",
  data() {
    return{

      dataAll: Data,
      itemData: {},
      colorData:{
        back:"#5daf34",
        p1:"#FFFFFF"
      },

    }
  },
  mounted() {
    let that = this;

    for(let index in that.dataAll){
      let itemData= that.dataAll[index];
      if(that.$parent.$parent.message == itemData.type){
        that.itemData = itemData;
        break;
      }
    }
    that.init();
  },
  methods:{
    init(){
      console.log("jjfa")
      let that = this;
      for(let index in that.itemData.itemData){
        let itemBom = that.itemData.itemData[index];
        if(itemBom.index === 1){
          that.imgUrl = itemBom.imgUrl;
          that.itemData.itemData[index].back = "#5daf34"
          that.itemData.itemData[index].p1 = "#FFFFFF"
        } else {
          that.itemData.itemData[index].back = "#FFFFFF"
          that.itemData.itemData[index].p1 = "#000000"
        }

      }
      console.log(2223333)
      console.log(that.itemData)

    },
    selectItem(indexx){
      let that = this;
      for(let index in that.itemData.itemData){
        let itemBom = that.itemData.itemData[index];
        if(itemBom.index == indexx){
          that.imgUrl = itemBom.imgUrl;
          that.itemData.itemData[index].back = "#5daf34"
          that.itemData.itemData[index].p1 = "#FFFFFF"
          this.$router.push('/companyProfile?path='+itemBom.path);
        } else {
          that.itemData.itemData[index].back = "#FFFFFF"
          that.itemData.itemData[index].p1 = "#000000"
        }

      }
    },
    mouseover(indexx){
      let that = this;
      for(let index in that.itemData.itemData){
        let itemBom = that.itemData.itemData[index];
        if(itemBom.index == indexx){
          that.imgUrl = itemBom.imgUrl;
          that.itemData.itemData[index].back = "#5daf34"
          that.itemData.itemData[index].p1 = "#FFFFFF"
        } else {
          that.itemData.itemData[index].back = "#FFFFFF"
          that.itemData.itemData[index].p1 = "#000000"
        }

      }
    },
    jjfaCK(){
      this.$router.push('/companyProfile');
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/image/jjfa.vue